import moment from "moment";

export default function groupBy(xs: any, key: any) {
    return xs.reduce(function (rv: any, x: any) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

export function dateToString(date: Date) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = date.getFullYear();
    const dateString = mm + '/' + dd + '/' + yyyy;
    return dateString;
}

export function dateToString2(dateParam: Date) {
    const date = new Date(dateParam);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
    const yyyy = date.getFullYear();
    const dateString = mm + '/' + dd + '/' + yyyy;
    return dateString;
}


type DateFormat = 'YYYY-MM-DD' | 'MM-DD-YYYY' | 'DD-MM-YYYY' | 'YYYY/MM/DD' | 'MM/DD/YYYY' | 'DD/MM/YYYY'

export const FormatDate = (date: string | moment.Moment | undefined, format: DateFormat): string => {
    if (!date) {
        return "";
    }

    let dateMoment: moment.Moment;

    if (typeof date === 'string') {
        dateMoment = moment(date);
        if (!dateMoment.isValid()) {
            return "";
        }
    } else if (moment.isMoment(date)) {
        dateMoment = date;
    } else {
        return "";
    }

    return dateMoment.format(format);
};

const POS_LABEL_MAX_CHARS = 20;

// Truncates POS dropdown display labels; value (ID) is preserved so API payloads are unaffected.
export function truncatePosLabel<T extends { label?: string }>(option: T): T {
    if (!option.label || option.label.length <= POS_LABEL_MAX_CHARS) return option;
    return { ...option, label: `${option.label.slice(0, POS_LABEL_MAX_CHARS)}...` };
}

